import React from "react";

import { Switch, Route } from "react-router-dom";

import LandingPage from "./pages/Landing";
import IndexPage from "./pages/IndexPage";
import RegistrationPage from "./pages/Registration";
import RegistrationVerifyPage from "./pages/RegistrationVerify";
import LoginPage from "./pages/Login";
import SessionPage from "./pages/Session";
import { readSessions } from "./helpers/session";
import ApiDocs from "./pages/ApiDocs";

import { BrowserRouter as Router } from "react-router-dom";
import Nav from "./common/components/Nav";

const MENU = [
  {
    label: "API Documentation",
    href: "/web/apidocs",
    icon: "function",
  },
  {
    label: "Register",
    href: "/web/register",
    icon: "new-person",
  },
  {
    label: "Login",
    href: "/web/login",
    icon: "log-in",
  },
];

function App() {
  window.document.title = "Pocket Secure New";

  const sessions = [];

  for (const session of readSessions()) {
    if (!sessions.length) {
      sessions.push({
        label: "Sessions",
      });
    }
    sessions.push({
      label:
        (session.firstName ? `${session.firstName} ${session.lastName}` : "") +
          ((session.email && ` [${session.email}]`) || "") || session.id,
      href: "/web/session/" + session.id,
      icon: "person",
    });
  }

  return (
    <Router>
      <Switch>
        <Route path="/docs">
          <div
            style={{
              position: "fixed",
              width: "100%",
              height: "100%",
              left: "0",
              top: "0",
              overflow: "auto",
            }}
          >
            <ApiDocs />
          </div>
        </Route>
        <Route path="/web">
          <Nav menu={[...MENU, ...sessions]} />
          <div id="body">
            <Switch>
              <Route path="/web/apidocs" component={ApiDocs} />
              <Route
                path="/web/register/verify/:registrationToken"
                component={RegistrationVerifyPage}
              />
              <Route path="/web/register" component={RegistrationPage} />
              <Route path="/web/session/:key/:tab/:subtab" component={SessionPage} />
              <Route path="/web/session/:key/:tab" component={SessionPage} />
              <Route path="/web/session/:key" component={SessionPage} />
              <Route path="/web/login" component={LoginPage} />
              <Route component={IndexPage} />
            </Switch>
          </div>
        </Route>
        <Route component={LandingPage} />
      </Switch>
    </Router>
  );
}

export default App;
